export default "assets/images/icons/fleche-up-634d2da8.svg";